import { useSelector } from '@betty/toolkit/state';
import {
  selectHasUnreadInboxMessages,
  selectInbox,
  selectInboxDataState,
} from '../state/inbox.slice';
import { useMemo } from 'react';

const useInbox = () => {
  const inbox = useSelector(selectInbox);
  const inboxDataState = useSelector(selectInboxDataState);
  const hasUnreadMessages = useSelector(selectHasUnreadInboxMessages);

  const returnObj = useMemo(
    () => ({
      inbox,
      inboxDataState,
      hasUnreadMessages,
    }),
    [inbox, inboxDataState, hasUnreadMessages],
  );

  return returnObj;
};

export default useInbox;
